import { render } from "./TemporaryLogin.vue?vue&type=template&id=4b6abd4a&scoped=true"
import script from "./TemporaryLogin.vue?vue&type=script&lang=js"
export * from "./TemporaryLogin.vue?vue&type=script&lang=js"

import "./TemporaryLogin.vue?vue&type=style&index=0&id=4b6abd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6abd4a"]])

export default __exports__